import { type FC, useCallback } from 'react';

import { useApplicationContext } from 'shared/utils/applicationContext';

import { type IPromo } from '../../types/promos';

import { PromoDetails } from './PromoDetails';
import { ActionButtons } from './components/ActionButtons';
import { getAuthorDescription } from './helpers/getAuthorDescription';
import { getAuthorLabel } from './helpers/getAuthorLabel';
import { getAuthorName } from './helpers/getAuthorName';
import { getMortgagePartnerLink } from './helpers/getMortgagePartnerLink';
import { trackCianMortgageClick } from './tracking';

type PromoDetailsContainerProps = {
  promo: IPromo;
  onModalClose: () => void;
};

export const PromoDetailsContainer: FC<PromoDetailsContainerProps> = props => {
  const { promo, onModalClose } = props;

  const { config } = useApplicationContext();

  const mortgagePartnerLink = getMortgagePartnerLink(promo, config);

  const handleMortgageClick = useCallback(() => {
    trackCianMortgageClick(promo);
  }, [promo]);

  const cianMortgage = promo.promoType === 'cianMortgage';

  return (
    <PromoDetails
      open
      authorDescription={getAuthorDescription(promo)}
      authorLabel={getAuthorLabel(promo)}
      authorLogoUrl={promo.authorLogoUrl}
      authorName={getAuthorName(promo)}
      bank={promo.bank}
      banks={promo.banks}
      contactsButton={<ActionButtons cianMortgage={cianMortgage} onMortgageClick={handleMortgageClick} />}
      description={promo.description}
      features={promo.features}
      mortgagePartnerLink={mortgagePartnerLink}
      subtitle={cianMortgage ? null : promo.end}
      title={promo.name}
      onClose={onModalClose}
      onMortgageClick={handleMortgageClick}
    />
  );
};
